import { Box, Text, View } from 'native-base';
import { ColoredDifferenceAmount } from '../index';
import React from 'react';
import Functions from '../../../utils/Functions';
const SummaryTableRowData = _ref => {
  let {
    title,
    previous,
    current,
    difference,
    fontWeight
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    flex: 2,
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'xs',
      md: 'sm',
      lg: 'sm'
    },
    fontWeight: fontWeight,
    accessibilityLabel: title,
    accessibilityRole: "text"
  }, title)), /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Text, {
    textAlign: "right",
    fontSize: {
      base: 'xs',
      md: 'sm',
      lg: 'sm'
    },
    fontWeight: fontWeight,
    accessibilityLabel: Functions.toUSD(previous),
    accessibilityRole: "text"
  }, Functions.toUSD(previous))), /*#__PURE__*/React.createElement(View, {
    flex: 1,
    alignItems: "flex-end",
    justifyContent: difference === 0 ? 'center' : 'flex-end'
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'xs',
      md: 'sm',
      lg: 'sm'
    },
    fontWeight: fontWeight,
    accessibilityLabel: Functions.toUSD(current),
    accessibilityRole: "text"
  }, Functions.toUSD(current)), /*#__PURE__*/React.createElement(ColoredDifferenceAmount, {
    difference: difference,
    key: 'twenty-five',
    id: 'twenty-five'
  })));
};
export default SummaryTableRowData;
//# sourceMappingURL=index.js.map